import gql from 'graphql-tag';

export default gql`
  mutation CreateUser(
    $email: String!
    $password: String!
    $name: String!
    $biography: String!
    $website: String
    $type: String!
    $theaterId: String
    $images: [UserImageInput]
  ) {
    createUser(
      email: $email
      password: $password
      name: $name
      biography: $biography
      website: $website
      type: $type
      theaterId: $theaterId
      images: $images
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/CreateUser.js